module.exports = __webpack_public_path__ + "static/media/hcfamemalogo2.010b7ddd.png";